import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import RevealText from "../components/RevealText";
import ScrollReveal from "../components/ScrollReveal";
import KorvTube from "../components/KorvTube";
import { COLLECTION } from "../constants/testIds";

export default function Collection() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-32 md:pt-44">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-3">
            <p className="text-[10px] uppercase tracking-eyebrow text-ink/60">Volume I</p>
            <p className="mt-2 text-[11px] uppercase tracking-editorial text-ink/70">Lip · Five Objects</p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <RevealText
              as="h1"
              className="font-serif-display text-[13vw] md:text-[9vw] leading-[0.9] tracking-[-0.02em]"
              lines={["The", <span key="i" className="italic font-serif-italic">Collection</span>]}
            />
          </div>
        </div>
        <div className="hairline mb-4" />
        <div className="grid grid-cols-12 gap-4 text-[10px] uppercase tracking-editorial text-ink/55">
          <span className="col-span-1">N°</span>
          <span className="col-span-4">Composition</span>
          <span className="col-span-3">Finish</span>
          <span className="col-span-2 hidden md:block">Volume</span>
          <span className="col-span-2 text-right">Reference</span>
        </div>
        <div className="hairline-soft mt-4" />
      </div>

      <ul data-testid={COLLECTION.list} className="max-w-[1600px] mx-auto px-6 md:px-10 mt-4">
        {products.map((p, i) => (
          <ScrollReveal key={p.slug} delay={i * 0.05}>
            <li>
              <Link
                to={`/collection/${p.slug}`}
                data-testid={COLLECTION.item(p.slug)}
                className="group block border-b border-ink/25 py-8 md:py-12"
              >
                <div className="grid grid-cols-12 gap-4 items-center">
                  <span className="col-span-1 chapter-num text-2xl md:text-3xl text-plum">00{i + 1}</span>
                  <span className="col-span-4 font-serif-display text-3xl md:text-6xl leading-none">
                    {p.name}
                  </span>
                  <span className="col-span-3 text-[13px] uppercase tracking-editorial text-ink/70">{p.tagline}</span>
                  <span className="col-span-2 hidden md:block text-[13px] text-ink/60">{p.volume}</span>
                  <span className="col-span-2 flex items-center justify-end gap-3 text-[13px] text-ink/70">
                    <span className="swatch-dot" style={{ background: p.swatch_hex }} />
                    {p.price_display}
                  </span>
                </div>
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  whileHover={{ height: "auto", opacity: 1 }}
                  className="overflow-hidden"
                >
                  <div className="grid grid-cols-12 gap-4 mt-6">
                    <div className="col-start-2 col-span-8 md:col-start-2 md:col-span-6 text-[15px] text-ink/70 max-w-[52ch]">
                      {p.description_short}
                    </div>
                  </div>
                </motion.div>
              </Link>
            </li>
          </ScrollReveal>
        ))}
      </ul>

      <div className="max-w-[1600px] mx-auto px-6 md:px-10 mt-24 md:mt-40 grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-5">
          <p className="text-[10px] uppercase tracking-eyebrow text-ink/60 mb-6">On material</p>
          <p className="font-serif-display text-3xl md:text-4xl leading-[1.1] max-w-[22ch]">
            Each composition is packed in weighted glass and shipped in a bone-toned carton, lithographed by hand in Copenhagen.
          </p>
        </div>
        <div className="col-span-12 md:col-span-6 md:col-start-7 grid grid-cols-2 gap-4">
          {products.slice(0, 4).map((p) => {
            const bgs = { "#141212":"#2a2724", "#e6ddcf":"#d9cfc0", "#b8a48c":"#c9baa4", "#3a2530":"#221820", "#c9a37a":"#e0d0b6" };
            const caps = { "#141212":"dark", "#e6ddcf":"light", "#c9a37a":"dark" };
            return (
              <div key={p.slug} className="relative aspect-[3/4] overflow-hidden" style={{ background: bgs[p.swatch_hex] || "#c9baa4" }}>
                <div className="absolute inset-0" style={{ background: "radial-gradient(58% 55% at 50% 42%, rgba(255,255,255,0.18), transparent 65%)" }} />
                <div className="absolute inset-0 flex items-center justify-center">
                  <KorvTube color={p.swatch_hex} cap={caps[p.swatch_hex] || "same"} sublabel={p.category.toUpperCase()} animate={false} className="h-[74%] w-auto drop-shadow-[0_20px_28px_rgba(20,18,17,0.35)]" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
